<script>
    import { push } from "svelte-spa-router";
    export let params;
    function Dashboard() {
        push("/dashboard/factories");
    }

    function CreateProduct() {
        push("/createproduct/" + params.factorySettingsId);
    }
</script>

<div style="width:400px; height:400px; background-color:#F00;color:white">
    factory saved
    <btn class="btn btn-primary" on:click={Dashboard}>Dashboard</btn>
    <btn class="btn btn-primary" on:click={CreateProduct}>Create product</btn>
</div>
